import * as Yup from "yup";
import { Rules } from "@/utils";

export const validationSchema = Yup.object().shape({
  title: Yup.string().trim().required("Title is required").max(Rules.MAX_TITLE, "Title is too long"),
  smartLinkId: Yup.number()
    .nullable()
    .when("linkType", {
      is: "SMART_LINK",
      then: schema => schema.required("A Smart Link must be selected"),
      otherwise: schema => schema.notRequired(),
    }),
});
